import React from "react";
import {Link} from "react-router-dom";

export const StyledLinkButton = ({
    to,
    target = "_blank",
    color = "#1890ff",
    backgroundColor = "#f0f9ff",
    borderColor = "#d1ecf1",
    hoverBackgroundColor = "#e6f7ff",
    hoverBorderColor = "#91d5ff",
    children,
    disabled = false,
    style = {},
    icon = null,
    ...props
}) => {
    const buttonStyle = {
        color: color,
        textDecoration: "none",
        fontWeight: "500",
        padding: "2px 8px",
        borderRadius: "4px",
        backgroundColor: backgroundColor,
        border: `1px solid ${borderColor}`,
        transition: "all 0.2s ease",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        cursor: "pointer",
        ...style
    };

    const disabledStyle = {
        ...buttonStyle,
        color: "#8c8c8c",
        backgroundColor: "#f5f5f5",
        border: "1px solid #d9d9d9",
        cursor: "default"
    };

    const handleMouseEnter = e => {
        if (!disabled) {
            e.target.style.backgroundColor = hoverBackgroundColor;
            e.target.style.borderColor = hoverBorderColor;
        }
    };

    const handleMouseLeave = e => {
        if (!disabled) {
            e.target.style.backgroundColor = backgroundColor;
            e.target.style.borderColor = borderColor;
        }
    };

    if (!to) {
        const spanStyle = {
            ...buttonStyle,
            cursor: style.cursor || "default"
        };
        return (
            <span style={spanStyle} {...props}>
                {icon && <span style={{fontSize: "12px"}}>{icon}</span>}
                {children}
            </span>
        );
    }

    if (disabled) {
        return (
            <span style={disabledStyle} {...props}>
                {icon && <span style={{fontSize: "12px"}}>{icon}</span>}
                {children}
            </span>
        );
    }

    return (
        <Link
            to={to}
            target={target}
            style={buttonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            {...props}
        >
            {icon && <span style={{fontSize: "12px"}}>{icon}</span>}
            {children}
        </Link>
    );
};
